import { isEmailAvailable } from './isEmailAvailable'
import { isCpfAvailable } from './isCpfAvailable'

export default { isEmailAvailable, isCpfAvailable }